var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-modal',{staticClass:"modal-video",attrs:{"show":_vm.modal_video_show}},[_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeVideoModal}}),_c('xd-video',{ref:"xdvideo",attrs:{"options":_vm.modal_video_options},on:{"after-create":_vm.handleCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }